.track {
	background: color-mix(in srgb, var(--bs-body-color) 9%, var(--bs-tertiary-bg));
	border: 1px solid color-mix(in srgb, var(--bs-border-color) 70%, transparent);
	border-radius: 9999px;
	box-shadow:
		inset 0 1px 2px rgb(0 0 0 / 0.06),
		0 1px 0 rgb(255 255 255 / 0.04);
	height: 0.7rem;
	overflow: hidden;
	position: relative;
}

[data-bs-theme="dark"] .track,
[data-bs-theme="oled"] .track {
	box-shadow: inset 0 1px 3px rgb(0 0 0 / 0.35);
}

.fill {
	position: relative;
	background: linear-gradient(
		105deg,
		color-mix(in srgb, var(--bs-primary) 72%, var(--bs-body-bg)),
		var(--bs-primary) 45%,
		color-mix(in srgb, var(--bs-primary) 78%, white)
	);
	border-radius: inherit;
	box-shadow:
		inset 0 1px 0 rgb(255 255 255 / 0.22),
		0 0 0 1px color-mix(in srgb, var(--bs-primary) 25%, transparent);
	height: 100%;
	min-width: 0;
	transition: width 0.55s cubic-bezier(0.33, 1, 0.68, 1);
}

.fill::after {
	background: linear-gradient(90deg, transparent, rgb(255 255 255 / 0.22), transparent);
	content: "";
	height: 100%;
	left: 0;
	opacity: 0.85;
	pointer-events: none;
	position: absolute;
	top: 0;
	transform: translateX(-100%);
	width: 40%;
}

@media (prefers-reduced-motion: no-preference) {
	.fillActive::after {
		animation: questBarShimmer 2.4s ease-in-out infinite;
	}
}

@keyframes questBarShimmer {
	0%,
	100% {
		transform: translateX(-100%);
	}

	50% {
		transform: translateX(350%);
	}
}

@media (prefers-reduced-motion: reduce) {
	.fill {
		transition: none;
	}
}
